<div class="error-modal-container">
  <div class="error-modal-container__error">{{ 'error_modal.Error' | translate }}</div>
  <div class="error-modal-container__content">
    <div *ngIf="errorTxt; else defaultTxt">{{ errorTxt | translate }}</div>
    <ng-template #defaultTxt>{{ 'error_modal.DefaultText' | translate }}</ng-template>
  </div>
  <div class="error-modal-container__btn-container">
    <ui-custom-button [btnTxt]="'info_modal.Okay' | translate" (clickEvent)="dismissModal()"></ui-custom-button>
  </div>
</div>
